import React, { useState, useEffect } from 'react';
import axios from 'axios';

function Login() {
  const [tab, setTab] = useState('login');
  const [loginMethod, setLoginMethod] = useState('email');
  const [form, setForm] = useState({ email: '', password: '', full_name: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('task')) {
      sessionStorage.setItem('redirectAfterLogin', window.location.search);
    }
  }, []);

  const update = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const redirectAfterLogin = () => {
    const saved = sessionStorage.getItem('redirectAfterLogin');
    sessionStorage.removeItem('redirectAfterLogin');
    window.location.href = saved || '/';
  };

  const handleLogin = async () => {
    if (!form.email || !form.password) return setError('Email i lozinka su obavezni.');
    setLoading(true);
    setError('');
    try {
      await axios.post('/auth/login', { email: form.email, password: form.password }, { withCredentials: true });
      redirectAfterLogin();
    } catch (err) {
      setError(err.response?.data?.error || 'Greška pri prijavi.');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    if (!form.email || !form.password || !form.full_name) return setError('Sva polja su obavezna.');
    if (form.password.length < 8) return setError('Lozinka mora imati najmanje 8 znakova.');
    setLoading(true);
    setError('');
    try {
      await axios.post('/auth/register', {
        email: form.email,
        password: form.password,
        full_name: form.full_name,
      }, { withCredentials: true });
      setSuccess('Registracija uspješna! Možeš se prijaviti.');
      setTab('login');
      setForm({ email: form.email, password: '', full_name: '' });
    } catch (err) {
      setError(err.response?.data?.error || 'Greška pri registraciji.');
    } finally {
      setLoading(false);
    }
  };

  const googleLoginUrl = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('task')) {
      sessionStorage.setItem('redirectAfterLogin', window.location.search);
    }
    return '/auth/google';
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#1a2a4a',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
    }}>
      <div style={{
        background: 'white',
        borderRadius: 16,
        padding: 40,
        width: '100%', maxWidth: 420,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        borderTop: '4px solid #d63031',
      }}>
        {/* Logo i naziv */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img src="/logo_login.png" alt="DVD Bukovac" style={{ width: 120, height: 120, objectFit: 'contain', marginBottom: 12 }} />
          <div style={{ fontSize: 26, fontWeight: 700, color: '#1a2a4a', letterSpacing: '-0.5px' }}>DVD Bukovac</div>
          <div style={{ fontSize: 12, color: '#b2bec3', marginTop: 2, letterSpacing: '2px', textTransform: 'uppercase' }}>Zagreb · Osnovano 1950.</div>
          <div style={{ fontSize: 14, color: '#636e72', marginTop: 8, fontWeight: 500 }}>Koordinapp</div>
        </div>

        {/* Tabovi */}
        <div style={{ display: 'flex', borderBottom: '2px solid #f5f6fa', marginBottom: 24 }}>
          {['login', 'register'].map(t => (
            <button key={t} onClick={() => { setTab(t); setError(''); setSuccess(''); }}
              style={{
                flex: 1, padding: '10px 0', border: 'none', background: 'none', cursor: 'pointer',
                fontSize: 16, fontWeight: 500,
                color: tab === t ? '#d63031' : '#636e72',
                borderBottom: tab === t ? '2px solid #d63031' : '2px solid transparent',
                marginBottom: -2, transition: 'all 0.2s',
              }}>
              {t === 'login' ? 'Prijava' : 'Registracija'}
            </button>
          ))}
        </div>

        {success && (
          <div style={{ background: '#d4edda', color: '#00b894', padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 16 }}>
            {success}
          </div>
        )}

        {tab === 'login' && (
          <>
            <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
              {['email', 'google'].map(m => (
                <button key={m} onClick={() => { setLoginMethod(m); setError(''); }}
                  style={{
                    flex: 1, padding: '8px 0',
                    border: `1px solid ${loginMethod === m ? '#1a2a4a' : '#dfe6e9'}`,
                    borderRadius: 8,
                    background: loginMethod === m ? '#eef2f7' : 'white',
                    color: loginMethod === m ? '#1a2a4a' : '#636e72',
                    cursor: 'pointer', fontSize: 14, fontWeight: 500,
                  }}>
                  {m === 'email' ? 'Email' : 'Google'}
                </button>
              ))}
            </div>

            {loginMethod === 'email' ? (
              <>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" value={form.email} onChange={e => update('email', e.target.value)} placeholder="tvoj@email.com" onKeyDown={e => e.key === 'Enter' && handleLogin()} />
                </div>
                <div className="form-group">
                  <label>Lozinka</label>
                  <input type="password" value={form.password} onChange={e => update('password', e.target.value)} placeholder="••••••••" onKeyDown={e => e.key === 'Enter' && handleLogin()} />
                </div>
                {error && <p className="error">{error}</p>}
                <button className="btn btn-primary" style={{ width: '100%', padding: 12, fontSize: 17, marginTop: 8, background: '#1a2a4a' }} onClick={handleLogin} disabled={loading}>
                  {loading ? 'Prijava...' : 'Prijavi se'}
                </button>
              </>
            ) : (
              <>
                {error && <p className="error">{error}</p>}
                <a href={googleLoginUrl()} style={{ textDecoration: 'none' }}>
                  <button className="btn" style={{
                    width: '100%', padding: 12, fontSize: 17,
                    background: 'white', border: '1px solid #dfe6e9',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10,
                  }}>
                    <svg width="18" height="18" viewBox="0 0 48 48">
                      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
                      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                    </svg>
                    Prijavi se s Googleom
                  </button>
                </a>
              </>
            )}
          </>
        )}

        {tab === 'register' && (
          <>
            <div className="form-group">
              <label>Ime i Prezime</label>
              <input value={form.full_name} onChange={e => update('full_name', e.target.value)} placeholder="Ivan Horvat" />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={form.email} onChange={e => update('email', e.target.value)} placeholder="tvoj@email.com" />
            </div>
            <div className="form-group">
              <label>Lozinka (min. 8 znakova)</label>
              <input type="password" value={form.password} onChange={e => update('password', e.target.value)} placeholder="••••••••" />
            </div>
            <p style={{ fontSize: 13, color: '#636e72', marginBottom: 16 }}>
              Registracija je moguća samo ako je tvoj email već dodan u sustav od strane administratora.
            </p>
            {error && <p className="error">{error}</p>}
            <button className="btn btn-primary" style={{ width: '100%', padding: 12, fontSize: 17, background: '#1a2a4a' }} onClick={handleRegister} disabled={loading}>
              {loading ? 'Registracija...' : 'Registriraj se'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Login;
